import { z } from 'zod';

// ---------------------------------------------------------------------------
// Cost estimate — §10.1 SPEC-CATEGORY-VARIANTS
// GET /v1/admin/pipeline/cost-estimate?top_n=&locales_count=
// ---------------------------------------------------------------------------

export const CostEstimateRequestSchema = z.object({
  top_n: z.coerce.number().int().min(1).max(10).optional(),
  locales_count: z.coerce.number().int().min(1).max(50).optional(),
});
export type CostEstimateRequest = z.infer<typeof CostEstimateRequestSchema>;

export const CostEstimateResponseSchema = z.object({
  avg_cost_per_variant: z.number().nonnegative(),
  /** Evidence behind avg_cost_per_variant; baseline fallback is an estimate. */
  cost_provenance: z.enum(['billed', 'estimate', 'unknown']),
  sample_size: z.number().int().nonnegative(),
  top_n: z.number().int().positive(),
  locales_count: z.number().int().positive(),
  wallpapers_count: z.number().int().nonnegative(),
  total_estimate_usd: z.number().nonnegative(),
});
export type CostEstimateResponse = z.infer<typeof CostEstimateResponseSchema>;

// ---------------------------------------------------------------------------
// Cost breakdown — §10.2 SPEC-CATEGORY-VARIANTS
// GET /v1/admin/wallpapers/:id/cost-breakdown
// ---------------------------------------------------------------------------

export const CostBreakdownRequestSchema = z.object({
  wallpaper_id: z.coerce.number().int().positive(),
});
export type CostBreakdownRequest = z.infer<typeof CostBreakdownRequestSchema>;

export const CostBreakdownItemSchema = z.object({
  // T5 (step3-rework): wallpapers_i18n has no category context; 0 is emitted as
  // a backward-compat placeholder. Changed from .positive() → .nonnegative().
  category_id: z.number().int().nonnegative(),
  lang_code: z.string(),
  cost_usd: z.number().nonnegative(),
  generated_at: z.string().nullable(),
});
export type CostBreakdownItem = z.infer<typeof CostBreakdownItemSchema>;

export const CostBreakdownResponseSchema = z.object({
  items: CostBreakdownItemSchema.array(),
  total_usd: z.number().nonnegative(),
});
export type CostBreakdownResponse = z.infer<typeof CostBreakdownResponseSchema>;
